const routes = [
    {
        path: "/courses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "course_index"
        },
        component_full_path: 'courses/pages/Index'
    }
]

export default routes;
